import React, { useEffect, useState, useContext } from 'react';
import {BrowserRouter, Route, Routes } from 'react-router-dom'; //Navigate
import * as DASHBOARD_ROUTES from './constants/dashboard_routes'
import "./css/Swiper.css"
import "./css/Popup.css"
import "./css/Animations.css"
import "./css/Style.css"
import "./css/Calculator.css"
import "./css/Dashboard.css"
import "./css/SuccessLoanForm.css"
import "./css/BecomeMemberForm.css"
import "./css/TransitionPage.css"

import { ThemeProvider } from "@mui/styles";
import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import './font-awesome-4.7.0/css/font-awesome.min.css'
import './font-awesome-4.7.0/css/font-awesome.css'
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import Notfound404 from './pages/NotFound404';
import Setup from './pages/online-bank-app/Setup';
import Redirect from './Redirect';

import { getFirestore, collection, addDoc } from "firebase/firestore";
import { FirebaseContext } from "./context/firebase";
import { doc, getDoc } from "firebase/firestore";
import userData from "./data/MitchellShakkadata.json"

const App: React.FC =()=> {

    const { firebase } = useContext(FirebaseContext)
    const db = getFirestore(firebase);


  //   const uploadJsonToFirebase = async () => {
  //     try {
  //       // Parse the JSON input
  //       const data = userData;

  //       // Make sure it's an object
  //       if (typeof data !== "object" || data === null) {
  //         alert("Invalid JSON: Must be an object");
  //         return;
  //       }

  //       // Add to Firestore collection named "test"
  //       await addDoc(collection(db, "bank-application-data"), data);

  //       alert("Document added successfully!");
  //     } catch (error: any) {
  //       alert("Error: " + error.message);
  //     }
  //   };


  // useEffect(()=>{
  //   uploadJsonToFirebase()
  // })

  // const getBankData = async () => {

  //   try {
  //     const docRef = doc(db, "bank-application-data", "QckX6qVFdWprFysrpo26");
  //     const docSnap = await getDoc(docRef);

  //     if (docSnap.exists()) {
  //       console.log("Bank Data:", docSnap.data());
  //     } else {
  //       console.log("Document not found.");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching bank data:", error);
  //   }
  // };
  // useEffect(() => {
  //   getBankData();
  // }, []);

  let theme = createTheme({
    breakpoints: {
      values: {
        xs: 0, // Extra small
        sm: 600, // Small
        md: 1000, // Medium
        lg: 1200, // Large
        xl: 1536, // Extra large
        // Add custom breakpoints here (e.g., xxl: 1800)
      }
    },
  });




  /*
=============================================================== 
//* AOS iNIT
===============================================================
*/
useEffect(()=> {
  AOS.init({
    duration: 400,
    easing: 'ease-in-sine',
    delay: 0,
    once: true,
  })
  AOS.refresh()

  return () => {
    AOS.refresh()
  }
}, [])

const [isLoggedIn, setIsLoggedIn] = useState(false)







  return (
      <ThemeProvider theme={theme}>
        <div className="App">
      
          <BrowserRouter>
            <Routes>
              <Route path={DASHBOARD_ROUTES.REDIRECT} element={<Redirect />}/>
              <Route path={DASHBOARD_ROUTES.HOME} element={<Setup name={'home'} settingName={''}/>}/>
              <Route path={DASHBOARD_ROUTES.TRANSFER} element={<Setup name={'send-money'} settingName={''}/>}/>
              <Route path={DASHBOARD_ROUTES.INVEST} element={<Setup name={'invest'} settingName={''}/>}/>
              <Route path={DASHBOARD_ROUTES.INVESTNEW} element={<Setup name={'invest-new'} settingName={''}/>}/>

              <Route path={DASHBOARD_ROUTES.BENEFICIARIES} element={<Setup name={'beneficiaries'} settingName={''}/>}/>
              <Route path={DASHBOARD_ROUTES.TRANSACTION_HISTORY} element={<Setup name={'transaction-history'} settingName={''}/>}/>
              <Route path={DASHBOARD_ROUTES.TRANSACTION_STATMENT} element={<Setup name={'account-statement'} settingName={''}/>}/>
              <Route path={DASHBOARD_ROUTES.MANAGE_BILL} element={<Setup name={'manage-bills'} settingName={''}/>}/>
              <Route path={DASHBOARD_ROUTES.PAY_BILL} element={<Setup name={'pay-bills'} settingName={''}/>}/>
              <Route path={DASHBOARD_ROUTES.ACCOUNT_SETTINGS} element={<Setup name={'settings'} settingName={'setting-profile'}/>}/>



              <Route path='/settings/profile' element={<Setup name={'settings'} settingName={'setting-profile'} />}/>
              <Route path='/settings/account-management' element={<Setup name={'settings'} settingName={'account-management'} />}/>
              <Route path='/settings/legal' element={<Setup name={'settings'} settingName={'legal'} />}/>
              <Route path='/settings/help' element={<Setup name={'settings'} settingName={'help'} />}/>



              <Route path='/pay-bills/utilities' element={<Setup name={'pay-bills-utilities'} settingName={''}/>}/>
              <Route path='/pay-bills/telecom' element={<Setup name={'pay-bills-telecom'} settingName={''}/>}/>
              <Route path='/pay-bills/cable-tv' element={<Setup name={'pay-bills-cable-tv'} settingName={''}/>}/>
              <Route path='/pay-bills/housing' element={<Setup name={'pay-bills-housing'} settingName={''}/>}/>
              <Route path='/pay-bills/loan' element={<Setup name={'pay-bills-loan'} settingName={''}/>}/>
              <Route path='/pay-bills/subscription' element={<Setup name={'pay-bills-subscription'} settingName={''}/>}/>
              <Route path='/pay-bills/custom' element={<Setup name={'pay-bills-custom'} settingName={''}/>}/>




              <Route path='*' element={<Notfound404 />}/>
      
            </Routes>
          </BrowserRouter>

        </div>
      </ThemeProvider>
  );
}

export default App;
